module.exports = __webpack_public_path__ + "static/customer-testimonial-bg-2-tablet-4622e89e2c71eeb419a2897ce6a5cd85.png";